import i18n from '@/translation/translation';
/**
 * Application Constants Guide
 *
 * How to add new constants:
 * 1. Add your string to `ui/src/public/en/common.json` with a descriptive key
 *    Example: "my_new_constant": "My New Text"
 *
 * 2. Reference it here using i18n.t() with the same key
 *    Example: get my_new_constant() { return i18n.t('my_new_constant') }
 *
 * This approach ensures all UI text is translatable and centrally managed.
 *
 * Note: Constants use getter functions to ensure translations are fetched dynamically
 * based on the current language, not frozen at module load time.
 */
export var constants = {
    get notification_enable_edge() {
        return i18n.t('notification_enable_edge');
    },
    get notification_enable_chrome() {
        return i18n.t('notification_enable_chrome');
    },
    get notification_enable_firefox() {
        return i18n.t('notification_enable_firefox');
    },
    get notification_enable_safari() {
        return i18n.t('notification_enable_safari');
    },
    get Copyright_text1() {
        return i18n.t('Copyright_text1');
    },
    get Copyright_text2() {
        return i18n.t('Copyright_text2');
    },
    get Copyright_text3() {
        return i18n.t('Copyright_text3');
    },
    get Copyright_text4() {
        return i18n.t('Copyright_text4');
    },
    get Login_button() {
        return i18n.t('Login_button');
    },
    get exit_msg() {
        return i18n.t('exit_msg');
    },
    get cancel() {
        return i18n.t('cancel');
    },
    get logout() {
        return i18n.t('logout');
    },
    get close() {
        return i18n.t('close');
    },
    get privacy() {
        return i18n.t('privacy');
    },
    get cookies() {
        return i18n.t('cookies');
    },
    get error_page_title() {
        return i18n.t('error_page_title');
    },
    error_page_description: function error_page_description(email) {
        return i18n.t('error_page_description', {
            email: email
        });
    },
    get terms_of_use() {
        return i18n.t('terms_of_use');
    },
    get appstore_login_title() {
        return i18n.t('appstore_login_title');
    },
    get appstore_login_description() {
        return i18n.t('appstore_login_description');
    },
    get appstore_login_button() {
        return i18n.t('appstore_login_button');
    },
    // --------------------- Notification Enable Instructions -------------------------
    get notification_disabled_prefix() {
        return i18n.t('notification_disabled_prefix');
    },
    get notification_enable_generic() {
        return i18n.t('notification_enable_generic');
    },
    // --------------------- End Notification Enable Instructions ---------------------
    // -----------------------------Notification Constants----------------------------------
    get NO_NOTIFICATIONS() {
        return i18n.t('NO_NOTIFICATIONS');
    },
    get MARK_ALL_AS_READ() {
        return i18n.t('MARK_ALL_AS_READ');
    },
    get LAST_WEEK() {
        return i18n.t('LAST_WEEK');
    },
    get LAST_MONTH() {
        return i18n.t('LAST_MONTH');
    },
    get THREE_MONTHS_AGO() {
        return i18n.t('THREE_MONTHS_AGO');
    },
    get ONE_YEAR_AGO() {
        return i18n.t('ONE_YEAR_AGO');
    },
    get OLDER() {
        return i18n.t('OLDER');
    },
    get NOTIFICATIONS() {
        return i18n.t('NOTIFICATIONS');
    },
    get ONLY_SHOW_UNREAD() {
        return i18n.t('ONLY_SHOW_UNREAD');
    },
    // -----------------------------End Notification Constants------------------------------
    // -----------------------------Constants for Product Selection page----------------------------------
    get welcome_title() {
        return i18n.t('welcome_title');
    },
    get welcome_content() {
        return i18n.t('welcome_content');
    },
    get selectTool_Line() {
        return i18n.t('selectTool_Line');
    },
    get title_forecasting() {
        return i18n.t('title_forecasting');
    },
    get content_forecasting() {
        return i18n.t('content_forecasting');
    },
    get button_demand_brain() {
        return i18n.t('button_demand_brain');
    },
    get title_featureFactory() {
        return i18n.t('title_featureFactory');
    },
    get policy_name_featureFactory() {
        return i18n.t('policy_name_featureFactory');
    },
    get content_featureFactory() {
        return i18n.t('content_featureFactory');
    },
    get button_featureFactory() {
        return i18n.t('button_featureFactory');
    },
    get title_conductor() {
        return i18n.t('title_conductor');
    },
    get content_conductor() {
        return i18n.t('content_conductor');
    },
    get button_conductor() {
        return i18n.t('button_conductor');
    },
    get button_associate_productivity() {
        return i18n.t('button_associate_productivity');
    },
    get button_self_service() {
        return i18n.t('button_self_service');
    },
    get button_segmentation() {
        return i18n.t('button_segmentation');
    },
    get button_idr() {
        return i18n.t('button_idr');
    },
    get button_insights_engine() {
        return i18n.t('button_insights_engine');
    },
    get title_associate_productivity() {
        return i18n.t('title_associate_productivity');
    },
    get title_self_service() {
        return i18n.t('title_self_service');
    },
    get title_segmentation() {
        return i18n.t('title_segmentation');
    },
    get title_idr() {
        return i18n.t('title_idr');
    },
    get title_insights_engine() {
        return i18n.t('title_insights_engine');
    },
    get heading1ConvergeTitle() {
        return i18n.t('heading1ConvergeTitle');
    },
    get heading2ConvergeTitle() {
        return i18n.t('heading2ConvergeTitle');
    },
    get your_apps() {
        return i18n.t('your_apps');
    },
    get open() {
        return i18n.t('open');
    },
    get unavailable() {
        return i18n.t('unavailable');
    },
    get email_your_admin() {
        return i18n.t('email_your_admin');
    },
    //------------------------------------End of Constants for Product Selection page--------------------
    //End of Constants for Product Selection page
    // --------------------- 404 Page ---------------------------------
    get title_404() {
        return i18n.t('title_404');
    },
    get desc_404() {
        return i18n.t('desc_404');
    },
    get return_to_home() {
        return i18n.t('return_to_home');
    },
    get page_crashed() {
        return i18n.t('page_crashed');
    },
    get no_app() {
        return i18n.t('no_app');
    },
    get wrong_app() {
        return i18n.t('wrong_app');
    },
    // --------------------- End of 404 Page -------------------------
    // --------------------- Access unavailable Page ---------------------------------
    get title_Access_unavailable() {
        return i18n.t('title_Access_unavailable');
    },
    get desc_Access_unavailable() {
        return i18n.t('desc_Access_unavailable');
    },
    // --------------------- End of Access unavailable Page -------------------------
    // --------------------- Settings ---------------------------------
    get apply() {
        return i18n.t('apply');
    },
    get settings_title() {
        return i18n.t('settings_title');
    },
    get settings_preferred_name_heading() {
        return i18n.t('settings_preferred_name_heading');
    },
    get settings_preferred_name_description() {
        return i18n.t('settings_preferred_name_description');
    },
    get settings_preferred_name_helper() {
        return i18n.t('settings_preferred_name_helper');
    },
    get settings_preferred_name_required() {
        return i18n.t('settings_preferred_name_required');
    },
    get settings_preferred_name_invalid_chars() {
        return i18n.t('settings_preferred_name_invalid_chars');
    },
    get settings_preferred_name_no_letter() {
        return i18n.t('settings_preferred_name_no_letter');
    },
    get settings_preferred_name_max_length() {
        return i18n.t('settings_preferred_name_max_length');
    },
    get settings_preferred_name_profanity_error() {
        return i18n.t('settings_preferred_name_profanity_error');
    },
    get settings_contact_number_heading() {
        return i18n.t('settings_contact_number_heading');
    },
    get settings_no_countries() {
        return i18n.t('settings_no_countries');
    },
    get settings_contact_number_description() {
        return i18n.t('settings_contact_number_description');
    },
    get settings_phone_number_required() {
        return i18n.t('settings_phone_number_required');
    },
    get settings_invalid_country_selected() {
        return i18n.t('settings_invalid_country_selected');
    },
    settings_invalid_phone_number: function settings_invalid_phone_number(country) {
        return i18n.t('settings_invalid_phone_number', {
            country: country
        });
    },
    settings_invalid_phone_number_format: function settings_invalid_phone_number_format(country) {
        return i18n.t('settings_invalid_phone_number_format', {
            country: country
        });
    },
    get settings_language_heading() {
        return i18n.t('settings_language_heading');
    },
    get settings_language_description() {
        return i18n.t('settings_language_description');
    },
    get settings_language_loading() {
        return i18n.t('settings_language_loading');
    },
    get settings_language_error() {
        return i18n.t('settings_language_error');
    },
    get settings_audio_heading() {
        return i18n.t('settings_audio_heading');
    },
    get settings_audio_off() {
        return i18n.t('settings_audio_off');
    },
    get settings_audio_on() {
        return i18n.t('settings_audio_on');
    },
    get settings_audio_aria_label() {
        return i18n.t('settings_audio_aria_label');
    },
    get settings_icon_alt() {
        return i18n.t('settings_icon_alt');
    },
    get settings_permission_update_denied() {
        return i18n.t('settings_permission_update_denied');
    },
    get settings_permissions_unverifiable() {
        return i18n.t('settings_permissions_unverifiable');
    },
    get settings_message_preferences_heading() {
        return i18n.t('settings_message_preferences_heading');
    },
    get settings_message_preferences_description() {
        return i18n.t('settings_message_preferences_description');
    },
    get settings_message_slack() {
        return i18n.t('settings_message_slack');
    },
    get settings_message_teams() {
        return i18n.t('settings_message_teams');
    },
    get settings_message_email() {
        return i18n.t('settings_message_email');
    },
    get settings_message_sms() {
        return i18n.t('settings_message_sms');
    },
    get settings_message_web_push_notification() {
        return i18n.t('settings_message_web_push_notification');
    },
    get settings_button_cancel() {
        return i18n.t('settings_button_cancel');
    },
    get settings_button_save() {
        return i18n.t('settings_button_save');
    },
    get loading() {
        return i18n.t('loading');
    },
    get saving() {
        return i18n.t('saving');
    },
    get processing() {
        return i18n.t('processing');
    },
    get push_notification() {
        return i18n.t('push_notification');
    },
    // --------------------- End of Settings -------------------------
    // --------------------- End of Administration -------------------------
    // --------------------- NPS Modal ---------------------------------
    // --------------------- NPS Modal ---------------------------------
    get nps_modal_title() {
        return i18n.t('nps_modal_title');
    },
    get nps_modal_subtitle() {
        return i18n.t('nps_modal_subtitle');
    },
    get nps_modal_button_skip() {
        return i18n.t('nps_modal_button_skip');
    },
    get nps_modal_button_submit() {
        return i18n.t('nps_modal_button_submit');
    },
    get nps_modal_feedback_success() {
        return i18n.t('nps_modal_feedback_success');
    },
    // --------------------- End of NPS Modal -------------------------
    // --------------------- Help Center ---------------------------------
    get default_help_center_product_name() {
        return i18n.t('default_help_center_product_name');
    },
    get help_center_index() {
        return i18n.t('help_center_index');
    },
    get help_center_content_not_available() {
        return i18n.t('help_center_content_not_available');
    },
    get help_center_title() {
        return i18n.t('help_center_title');
    },
    get help_center_error_title() {
        return i18n.t('help_center_error_title');
    },
    get help_center_search_placeholder() {
        return i18n.t('help_center_search_placeholder');
    },
    // --------------------- End of Help Center -------------------------
    // --------------------- Home Page ---------------------------------
    get home_error_access_token_not_found() {
        return i18n.t('home_error_access_token_not_found');
    },
    get home_error_user_name_not_found() {
        return i18n.t('home_error_user_name_not_found');
    },
    get home_header_logo_alt() {
        return i18n.t('home_header_logo_alt');
    },
    get home_page_image_alt() {
        return i18n.t('home_page_image_alt');
    },
    // --------------------- End Home Page ------------------------------
    // --------------------- Feedback ---------------------------------
    get attachment_label() {
        return i18n.t('attachment_label');
    },
    get drag_drop_upload() {
        return i18n.t('drag_drop_upload');
    },
    get browse_file() {
        return i18n.t('browse_file');
    },
    get feedback() {
        return i18n.t('feedback');
    },
    get enhancement_desc() {
        return i18n.t('enhancement_desc');
    },
    get enhancement_title() {
        return i18n.t('enhancement_title');
    },
    get issue_title() {
        return i18n.t('issue_title');
    },
    get issue_desc() {
        return i18n.t('issue_desc');
    },
    get issue_description_placeholder() {
        return i18n.t('issue_description_placeholder');
    },
    get suggestion_description_placeholder() {
        return i18n.t('suggestion_description_placeholder');
    },
    get max_1000_chars() {
        return i18n.t('max_1000_chars');
    },
    get reached_max_limit() {
        return i18n.t('reached_max_limit');
    },
    get feedback_profanity_error() {
        return i18n.t('feedback_profanity_error');
    },
    get submitting() {
        return i18n.t('submitting');
    },
    get submit() {
        return i18n.t('submit');
    },
    get ticket_number() {
        return i18n.t('ticket_number');
    },
    get for_reference() {
        return i18n.t('for_reference');
    },
    get success_title() {
        return i18n.t('success_title');
    },
    // --------------------- End Feedback -------------------------
    // --------------------- Feedback Error Modal ---------------------------------
    get feedback_error_modal_title() {
        return i18n.t('feedback_error_modal_title');
    },
    feedback_error_modal_description: function feedback_error_modal_description(email) {
        return i18n.t('feedback_error_modal_description', {
            email: email
        });
    },
    get feedback_error_modal_profanity_description() {
        return i18n.t('feedback_error_modal_profanity_description');
    },
    get feedback_error_modal_button_close() {
        return i18n.t('feedback_error_modal_button_close');
    },
    // --------------------- End Feedback Error Modal -------------------------
    // --------------------- RBAC Constants -------------------------
    get rbac_user_status_active() {
        return i18n.t('rbac_user_status_active');
    },
    get rbac_user_status_pending() {
        return i18n.t('rbac_user_status_pending');
    },
    get rbac_user_status_inactive() {
        return i18n.t('rbac_user_status_inactive');
    },
    // --------------------- End of RBAC Constants -------------------------
    // --------------------- Terms of Use -------------------------
    get terms_of_use_title() {
        return i18n.t('terms_of_use_title');
    },
    get terms_of_use_intro() {
        return i18n.t('terms_of_use_intro');
    },
    get terms_of_use_content_heading() {
        return i18n.t('terms_of_use_content_heading');
    },
    get terms_of_use_content_para1() {
        return i18n.t('terms_of_use_content_para1');
    },
    get terms_of_use_content_para2() {
        return i18n.t('terms_of_use_content_para2');
    },
    get terms_of_use_content_para3() {
        return i18n.t('terms_of_use_content_para3');
    },
    get terms_of_use_disclaimers_heading() {
        return i18n.t('terms_of_use_disclaimers_heading');
    },
    get terms_of_use_disclaimers_para1() {
        return i18n.t('terms_of_use_disclaimers_para1');
    },
    get terms_of_use_disclaimers_para2() {
        return i18n.t('terms_of_use_disclaimers_para2');
    },
    get terms_of_use_disclaimers_para3() {
        return i18n.t('terms_of_use_disclaimers_para3');
    },
    get terms_of_use_disclaimers_para4() {
        return i18n.t('terms_of_use_disclaimers_para4');
    },
    get terms_of_use_additional_heading() {
        return i18n.t('terms_of_use_additional_heading');
    },
    get terms_of_use_additional_para1() {
        return i18n.t('terms_of_use_additional_para1');
    },
    get terms_of_use_additional_para2() {
        return i18n.t('terms_of_use_additional_para2');
    },
    // --------------------- End of Terms of Use -------------------------
    get administration() {
        return i18n.t('administration');
    },
    get administration_description() {
        return i18n.t('administration_description');
    },
    get administration_subtitle() {
        return i18n.t('administration_subtitle');
    },
    // --------------------- Configuration Modal -------------------------
    get configuration_modal_title_add() {
        return i18n.t('configuration_modal_title_add');
    },
    get configuration_modal_title_edit() {
        return i18n.t('configuration_modal_title_edit');
    },
    get configuration_modal_field_system() {
        return i18n.t('configuration_modal_field_system');
    },
    get configuration_modal_field_key() {
        return i18n.t('configuration_modal_field_key');
    },
    get configuration_modal_field_value_type() {
        return i18n.t('configuration_modal_field_value_type');
    },
    get configuration_modal_field_value() {
        return i18n.t('configuration_modal_field_value');
    },
    get configuration_modal_error_select_type() {
        return i18n.t('configuration_modal_error_select_type');
    },
    get configuration_modal_error_key_required() {
        return i18n.t('configuration_modal_error_key_required');
    },
    get configuration_modal_error_value_required() {
        return i18n.t('configuration_modal_error_value_required');
    },
    get configuration_modal_error_number_invalid() {
        return i18n.t('configuration_modal_error_number_invalid');
    },
    get configuration_modal_error_boolean_invalid() {
        return i18n.t('configuration_modal_error_boolean_invalid');
    },
    get configuration_modal_error_json_invalid() {
        return i18n.t('configuration_modal_error_json_invalid');
    },
    get configuration_modal_button_add() {
        return i18n.t('configuration_modal_button_add');
    },
    get configuration_modal_button_update() {
        return i18n.t('configuration_modal_button_update');
    },
    get configuration_modal_button_adding() {
        return i18n.t('configuration_modal_button_adding');
    },
    get configuration_modal_button_updating() {
        return i18n.t('configuration_modal_button_updating');
    },
    get configuration_modal_submit_create_failed() {
        return i18n.t('configuration_modal_submit_create_failed');
    },
    get configuration_modal_submit_update_failed() {
        return i18n.t('configuration_modal_submit_update_failed');
    },
    // --------------------- End Configuration Modal ---------------------
    // --------------------- Add User Modal -------------------------------
    get add_user_modal_title() {
        return i18n.t('add_user_modal_title');
    },
    get edit_user_modal_title() {
        return i18n.t('edit_user_modal_title');
    },
    get add_user_modal_app_access() {
        return i18n.t('add_user_modal_app_access');
    },
    get add_user_modal_email() {
        return i18n.t('add_user_modal_email');
    },
    get add_user_modal_first_name() {
        return i18n.t('add_user_modal_first_name');
    },
    get add_user_modal_last_name() {
        return i18n.t('add_user_modal_last_name');
    },
    get add_user_modal_phone_number() {
        return i18n.t('add_user_modal_phone_number');
    },
    get add_user_modal_role() {
        return i18n.t('add_user_modal_role');
    },
    get add_user_modal_add_another_member() {
        return i18n.t('add_user_modal_add_another_member');
    },
    get add_user_modal_email_invalid() {
        return i18n.t('add_user_modal_email_invalid');
    },
    get add_user_modal_email_validation_failed() {
        return i18n.t('add_user_modal_email_validation_failed');
    },
    get add_user_modal_email_validate_failed() {
        return i18n.t('add_user_modal_email_validate_failed');
    },
    // --------------------- End Add User Modal ---------------------------
    // --------------------- File Input Buttons --------------------------
    get confirm() {
        return i18n.t('confirm');
    },
    get file_input_upload() {
        return i18n.t('file_input_upload');
    },
    get file_input_remove() {
        return i18n.t('file_input_remove');
    },
    get file_input_supported_formats_line() {
        return i18n.t('file_input_supported_formats_line');
    },
    get file_input_remove_image_confirm_body() {
        return i18n.t('file_input_remove_image_confirm_body');
    },
    // --------------------- Submit Settings ----------------------------
    get submit_settings_discard_changes() {
        return i18n.t('submit_settings_discard_changes');
    },
    get submit_settings_save_changes() {
        return i18n.t('submit_settings_save_changes');
    },
    get submit_settings_discard_title() {
        return i18n.t('submit_settings_discard_title');
    },
    get submit_settings_discard_body() {
        return i18n.t('submit_settings_discard_body');
    },
    get submit_settings_save_title() {
        return i18n.t('submit_settings_save_title');
    },
    get submit_settings_save_body() {
        return i18n.t('submit_settings_save_body');
    },
    // --------------------- File Picker ---------------------------------
    get or() {
        return i18n.t('or');
    },
    file_picker_supported_types_line: function file_picker_supported_types_line(types, size) {
        return i18n.t('file_picker_supported_types_line', {
            types: types,
            size: size
        });
    },
    file_picker_error_invalid_type: function file_picker_error_invalid_type(name, types) {
        return i18n.t('file_picker_error_invalid_type', {
            name: name,
            types: types
        });
    },
    file_picker_error_max_size: function file_picker_error_max_size(size) {
        return i18n.t('file_picker_error_max_size', {
            size: size
        });
    },
    // --------------------- End File Picker -----------------------------
    // --------------------- Notification Modal --------------------------
    get notification_default_title() {
        return i18n.t('notification_default_title');
    },
    get notification_rating_thanks() {
        return i18n.t('notification_rating_thanks');
    },
    get loading_more() {
        return i18n.t('loading_more');
    },
    // --------------------- End Notification Modal ----------------------
    // --------------------- PermissionGate ------------------------------
    get permission_gate_unauthorized_tooltip() {
        return i18n.t('permission_gate_unauthorized_tooltip');
    },
    // --------------------- End PermissionGate --------------------------
    // --------------------- Policy Modal -------------------------------
    policy_modal_title_add: function policy_modal_title_add(workspace) {
        return i18n.t('policy_modal_title_add', {
            workspace: workspace
        });
    },
    policy_modal_title_edit: function policy_modal_title_edit(workspace) {
        return i18n.t('policy_modal_title_edit', {
            workspace: workspace
        });
    },
    get workspace_default_name() {
        return i18n.t('workspace_default_name');
    },
    get policy_modal_field_name() {
        return i18n.t('policy_modal_field_name');
    },
    get policy_modal_deny() {
        return i18n.t('policy_modal_deny');
    },
    get policy_modal_allow() {
        return i18n.t('policy_modal_allow');
    },
    get policy_modal_json_editor_label() {
        return i18n.t('policy_modal_json_editor_label');
    },
    get policy_modal_json_preview_label() {
        return i18n.t('policy_modal_json_preview_label');
    },
    get policy_modal_switch_to_preview() {
        return i18n.t('policy_modal_switch_to_preview');
    },
    get policy_modal_edit_json() {
        return i18n.t('policy_modal_edit_json');
    },
    get policy_modal_json_editor_tip() {
        return i18n.t('policy_modal_json_editor_tip');
    },
    get policy_modal_reset_from_form() {
        return i18n.t('policy_modal_reset_from_form');
    },
    get policy_modal_json_placeholder() {
        return i18n.t('policy_modal_json_placeholder');
    },
    get policy_modal_error_name_required() {
        return i18n.t('policy_modal_error_name_required');
    },
    get policy_modal_error_resource_action_required() {
        return i18n.t('policy_modal_error_resource_action_required');
    },
    // --------------------- End Policy Modal ----------------------------
    // --------------------- Role Modal ---------------------------------
    role_modal_title_add: function role_modal_title_add(workspace) {
        return i18n.t('role_modal_title_add', {
            workspace: workspace
        });
    },
    role_modal_title_edit: function role_modal_title_edit(workspace) {
        return i18n.t('role_modal_title_edit', {
            workspace: workspace
        });
    },
    get role_modal_select_app_warning() {
        return i18n.t('role_modal_select_app_warning');
    },
    get role_modal_field_role_name() {
        return i18n.t('role_modal_field_role_name');
    },
    get role_modal_policies_optional() {
        return i18n.t('role_modal_policies_optional');
    },
    get role_modal_loading_policies() {
        return i18n.t('role_modal_loading_policies');
    },
    get role_modal_select() {
        return i18n.t('role_modal_select');
    },
    get role_modal_error_policies_load_failed() {
        return i18n.t('role_modal_error_policies_load_failed');
    },
    // --------------------- End Role Modal ------------------------------
    // --------------------- User Group Modal ---------------------------
    usergroup_modal_title_add: function usergroup_modal_title_add(workspace) {
        return i18n.t('usergroup_modal_title_add', {
            workspace: workspace
        });
    },
    usergroup_modal_title_edit: function usergroup_modal_title_edit(workspace) {
        return i18n.t('usergroup_modal_title_edit', {
            workspace: workspace
        });
    },
    get usergroup_modal_field_group_name() {
        return i18n.t('usergroup_modal_field_group_name');
    },
    get usergroup_modal_field_roles() {
        return i18n.t('usergroup_modal_field_roles');
    },
    get usergroup_modal_select() {
        return i18n.t('usergroup_modal_select');
    },
    // --------------------- End User Group Modal -----------------------
    // --------------------- Application Modal --------------------------
    get application_modal_title_add() {
        return i18n.t('application_modal_title_add');
    },
    get application_modal_title_edit() {
        return i18n.t('application_modal_title_edit');
    },
    get application_modal_field_name() {
        return i18n.t('application_modal_field_name');
    },
    get application_modal_field_description() {
        return i18n.t('application_modal_field_description');
    },
    get application_modal_field_type() {
        return i18n.t('application_modal_field_type');
    },
    get application_modal_field_product_name() {
        return i18n.t('application_modal_field_product_name');
    },
    get application_modal_field_url() {
        return i18n.t('application_modal_field_url');
    },
    get application_modal_field_app_description() {
        return i18n.t('application_modal_field_app_description');
    },
    get application_modal_field_app_state() {
        return i18n.t('application_modal_field_app_state');
    },
    get application_modal_placeholder_name() {
        return i18n.t('application_modal_placeholder_name');
    },
    get application_modal_placeholder_description() {
        return i18n.t('application_modal_placeholder_description');
    },
    get application_modal_placeholder_product_name() {
        return i18n.t('application_modal_placeholder_product_name');
    },
    get application_modal_placeholder_url() {
        return i18n.t('application_modal_placeholder_url');
    },
    get application_modal_placeholder_app_description() {
        return i18n.t('application_modal_placeholder_app_description');
    },
    get application_modal_type_single() {
        return i18n.t('application_modal_type_single');
    },
    get application_modal_type_group() {
        return i18n.t('application_modal_type_group');
    },
    get application_modal_state_inactive() {
        return i18n.t('application_modal_state_inactive');
    },
    get application_modal_state_active() {
        return i18n.t('application_modal_state_active');
    },
    get application_modal_image_drag_drop() {
        return i18n.t('application_modal_image_drag_drop');
    },
    get application_modal_image_browse() {
        return i18n.t('application_modal_image_browse');
    },
    get application_modal_image_title_default() {
        return i18n.t('application_modal_image_title_default');
    },
    get application_modal_max_characters() {
        return i18n.t('application_modal_max_characters');
    },
    get application_modal_error_name_required() {
        return i18n.t('application_modal_error_name_required');
    },
    get application_modal_error_type_required() {
        return i18n.t('application_modal_error_type_required');
    },
    get application_modal_error_product_name_required() {
        return i18n.t('application_modal_error_product_name_required');
    },
    get application_modal_error_url_required() {
        return i18n.t('application_modal_error_url_required');
    },
    get application_page_unknown_date() {
        return i18n.t('application_page_unknown_date');
    },
    get application_page_load_failed() {
        return i18n.t('application_page_load_failed');
    },
    get application_page_save_failed() {
        return i18n.t('application_page_save_failed');
    },
    get application_page_updated_success() {
        return i18n.t('application_page_updated_success');
    },
    get application_page_created_success() {
        return i18n.t('application_page_created_success');
    },
    get application_page_deleted_success() {
        return i18n.t('application_page_deleted_success');
    },
    get application_page_delete_failed() {
        return i18n.t('application_page_delete_failed');
    },
    get application_page_access_denied() {
        return i18n.t('application_page_access_denied');
    },
    get application_page_no_permission() {
        return i18n.t('application_page_no_permission');
    },
    get application_page_description() {
        return i18n.t('application_page_description');
    },
    get application_page_button_application() {
        return i18n.t('application_page_button_application');
    },
    get application_page_loading() {
        return i18n.t('application_page_loading');
    },
    get application_page_no_applications() {
        return i18n.t('application_page_no_applications');
    },
    get application_page_edit() {
        return i18n.t('application_page_edit');
    },
    get application_page_delete() {
        return i18n.t('application_page_delete');
    },
    // --------------------- End Application Modal ----------------------
    // --------------------- User Details Modal -------------------------
    user_details_date_added: function user_details_date_added(date) {
        return i18n.t('user_details_date_added', {
            date: date
        });
    },
    get user_details_workspace_role() {
        return i18n.t('user_details_workspace_role');
    },
    get user_details_applications_header_application() {
        return i18n.t('user_details_applications_header_application');
    },
    get user_details_applications_header_access() {
        return i18n.t('user_details_applications_header_access');
    },
    get user_details_no_roles_selected() {
        return i18n.t('user_details_no_roles_selected');
    },
    get user_details_load_failed() {
        return i18n.t('user_details_load_failed');
    },
    get user_details_update_access_failed() {
        return i18n.t('user_details_update_access_failed');
    },
    // --------------------- End User Details Modal ----------------------
    // --------------------- Configuration Labels -----------------------
    get configuration_type_system() {
        return i18n.t('configuration_type_system');
    },
    get configuration_type_user_experience() {
        return i18n.t('configuration_type_user_experience');
    },
    get configuration_type_app_configuration() {
        return i18n.t('configuration_type_app_configuration');
    },
    get configuration_type_db_configuration() {
        return i18n.t('configuration_type_db_configuration');
    },
    get configuration_type_system_protected_read_only() {
        return i18n.t('configuration_type_system_protected_read_only');
    },
    get configuration_value_type_text() {
        return i18n.t('configuration_value_type_text');
    },
    get configuration_value_type_number() {
        return i18n.t('configuration_value_type_number');
    },
    get configuration_value_type_boolean() {
        return i18n.t('configuration_value_type_boolean');
    },
    get configuration_value_type_json_object() {
        return i18n.t('configuration_value_type_json_object');
    },
    // --------------------- End Configuration Labels -------------------
    // --------------------- Configuration Page -------------------------
    get configuration_filter_all_types() {
        return i18n.t('configuration_filter_all_types');
    },
    get configuration_add_button() {
        return i18n.t('configuration_add_button');
    },
    get configuration_table_header_key() {
        return i18n.t('configuration_table_header_key');
    },
    get configuration_table_header_value() {
        return i18n.t('configuration_table_header_value');
    },
    get configuration_table_header_type_of_value() {
        return i18n.t('configuration_table_header_type_of_value');
    },
    get configuration_table_header_actions() {
        return i18n.t('configuration_table_header_actions');
    },
    get configuration_loading() {
        return i18n.t('configuration_loading');
    },
    get configuration_empty() {
        return i18n.t('configuration_empty');
    },
    configuration_delete_confirm_body: function configuration_delete_confirm_body(type) {
        return i18n.t('configuration_delete_confirm_body', {
            type: type
        });
    },
    get delete() {
        return i18n.t('delete');
    },
    get common_table_header_action() {
        return i18n.t('common_table_header_action');
    },
    get global_roles() {
        return i18n.t('global_roles');
    },
    get global_policies() {
        return i18n.t('global_policies');
    },
    // --------------------- End Configuration Page ---------------------
    // --------------------- Policy Management --------------------------
    get policy_mgmt_access_denied_title() {
        return i18n.t('policy_mgmt_access_denied_title');
    },
    get policy_mgmt_access_denied_desc() {
        return i18n.t('policy_mgmt_access_denied_desc');
    },
    get policy_mgmt_header_description() {
        return i18n.t('policy_mgmt_header_description');
    },
    get policy_mgmt_application_label() {
        return i18n.t('policy_mgmt_application_label');
    },
    get policy_mgmt_add_button() {
        return i18n.t('policy_mgmt_add_button');
    },
    get policy_mgmt_loading() {
        return i18n.t('policy_mgmt_loading');
    },
    get policy_mgmt_error_load_policies() {
        return i18n.t('policy_mgmt_error_load_policies');
    },
    get policy_mgmt_error_save_policy() {
        return i18n.t('policy_mgmt_error_save_policy');
    },
    get policy_mgmt_select_app_before_create() {
        return i18n.t('policy_mgmt_select_app_before_create');
    },
    get policy_mgmt_update_success() {
        return i18n.t('policy_mgmt_update_success');
    },
    get policy_mgmt_add_success() {
        return i18n.t('policy_mgmt_add_success');
    },
    get policy_mgmt_delete_success() {
        return i18n.t('policy_mgmt_delete_success');
    },
    get policy_mgmt_error_delete_policy() {
        return i18n.t('policy_mgmt_error_delete_policy');
    },
    get policy_mgmt_error_bulk_delete() {
        return i18n.t('policy_mgmt_error_bulk_delete');
    },
    get policy_mgmt_no_policies_found() {
        return i18n.t('policy_mgmt_no_policies_found');
    },
    get policy_mgmt_no_spec() {
        return i18n.t('policy_mgmt_no_spec');
    },
    get policy_mgmt_table_header_name() {
        return i18n.t('policy_mgmt_table_header_name');
    },
    get policy_mgmt_table_header_specification() {
        return i18n.t('policy_mgmt_table_header_specification');
    },
    get policy_mgmt_table_header_actions() {
        return i18n.t('policy_mgmt_table_header_actions');
    },
    policy_mgmt_delete_confirm_body: function policy_mgmt_delete_confirm_body(name) {
        return i18n.t('policy_mgmt_delete_confirm_body', {
            name: name
        });
    },
    policy_mgmt_bulk_delete_confirm_body: function policy_mgmt_bulk_delete_confirm_body(count) {
        var key = count === 1 ? 'policy_mgmt_bulk_delete_confirm_body_one' : 'policy_mgmt_bulk_delete_confirm_body_other';
        return i18n.t(key, {
            count: count
        });
    },
    get policy_mgmt_word_policy() {
        return i18n.t('policy_mgmt_word_policy');
    },
    get policy_mgmt_word_policies() {
        return i18n.t('policy_mgmt_word_policies');
    },
    get policy_mgmt_phrase_deleted_successfully() {
        return i18n.t('policy_mgmt_phrase_deleted_successfully');
    },
    get policy_mgmt_phrase_failed_to_delete_suffix() {
        return i18n.t('policy_mgmt_phrase_failed_to_delete_suffix');
    },
    // --------------------- End Policy Management ----------------------
    // --------------------- Role Management ---------------------------
    get role_mgmt_access_denied_title() {
        return i18n.t('role_mgmt_access_denied_title');
    },
    get role_mgmt_access_denied_desc() {
        return i18n.t('role_mgmt_access_denied_desc');
    },
    get role_mgmt_header_description() {
        return i18n.t('role_mgmt_header_description');
    },
    // Prefer reusing policy_mgmt_application_label in pages to avoid duplicates
    get role_mgmt_add_button() {
        return i18n.t('role_mgmt_add_button');
    },
    get role_mgmt_loading() {
        return i18n.t('role_mgmt_loading');
    },
    get role_mgmt_no_roles_found() {
        return i18n.t('role_mgmt_no_roles_found');
    },
    get role_mgmt_table_header_name() {
        return i18n.t('role_mgmt_table_header_name');
    },
    get role_mgmt_table_header_policies_assigned() {
        return i18n.t('role_mgmt_table_header_policies_assigned');
    },
    get role_mgmt_table_header_people_assigned() {
        return i18n.t('role_mgmt_table_header_people_assigned');
    },
    get role_mgmt_table_header_date_added() {
        return i18n.t('role_mgmt_table_header_date_added');
    },
    get role_mgmt_table_header_actions() {
        return i18n.t('role_mgmt_table_header_actions');
    },
    get role_mgmt_chip_no_policies() {
        return i18n.t('role_mgmt_chip_no_policies');
    },
    get role_mgmt_select_app_before_create() {
        return i18n.t('role_mgmt_select_app_before_create');
    },
    get role_mgmt_error_load_data() {
        return i18n.t('role_mgmt_error_load_data');
    },
    get role_mgmt_missing_info_update() {
        return i18n.t('role_mgmt_missing_info_update');
    },
    get role_mgmt_error_save_role() {
        return i18n.t('role_mgmt_error_save_role');
    },
    get role_mgmt_error_delete_role() {
        return i18n.t('role_mgmt_error_delete_role');
    },
    get role_mgmt_update_success() {
        return i18n.t('role_mgmt_update_success');
    },
    get role_mgmt_add_success() {
        return i18n.t('role_mgmt_add_success');
    },
    get role_mgmt_delete_success() {
        return i18n.t('role_mgmt_delete_success');
    },
    role_mgmt_delete_confirm_body: function role_mgmt_delete_confirm_body(name) {
        return i18n.t('role_mgmt_delete_confirm_body', {
            name: name
        });
    },
    // --------------------- End Role Management -----------------------
    // --------------------- Settings Page -----------------------------
    get settings_page_title() {
        return i18n.t('settings_page_title');
    },
    get settings_no_access_title() {
        return i18n.t('settings_no_access_title');
    },
    get settings_no_access_desc() {
        return i18n.t('settings_no_access_desc');
    },
    get settings_tab_team_access() {
        return i18n.t('settings_tab_team_access');
    },
    get settings_tab_user_groups() {
        return i18n.t('settings_tab_user_groups');
    },
    get settings_tab_roles() {
        return i18n.t('settings_tab_roles');
    },
    get settings_roles_no_assigned() {
        return i18n.t('settings_roles_no_assigned');
    },
    get settings_tab_policies() {
        return i18n.t('settings_tab_policies');
    },
    get settings_tab_theme() {
        return i18n.t('settings_tab_theme');
    },
    get settings_tab_configuration() {
        return i18n.t('settings_tab_configuration');
    },
    // --------------------- End Settings Page -------------------------
    // --------------------- Team Access Page --------------------------
    get team_access_access_denied_title() {
        return i18n.t('team_access_access_denied_title');
    },
    get team_access_access_denied_desc() {
        return i18n.t('team_access_access_denied_desc');
    },
    get team_access_access_label() {
        return i18n.t('team_access_access_label');
    },
    get team_access_loading_applications() {
        return i18n.t('team_access_loading_applications');
    },
    get team_access_add_member_button() {
        return i18n.t('team_access_add_member_button');
    },
    get team_access_header_description() {
        return i18n.t('team_access_header_description');
    },
    get team_access_table_header_name() {
        return i18n.t('team_access_table_header_name');
    },
    get team_access_table_header_email() {
        return i18n.t('team_access_table_header_email');
    },
    get team_access_table_header_phone_number() {
        return i18n.t('team_access_table_header_phone_number');
    },
    get team_access_table_header_role() {
        return i18n.t('team_access_table_header_role');
    },
    get team_access_table_header_group() {
        return i18n.t('team_access_table_header_group');
    },
    get team_access_table_header_status() {
        return i18n.t('team_access_table_header_status');
    },
    get team_access_table_header_registration_email() {
        return i18n.t('team_access_table_header_registration_email');
    },
    get team_access_table_header_reset_password() {
        return i18n.t('team_access_table_header_reset_password');
    },
    get team_access_table_header_date_added() {
        return i18n.t('team_access_table_header_date_added');
    },
    get team_access_table_header_action() {
        return i18n.t('team_access_table_header_action');
    },
    get team_access_loading_roles() {
        return i18n.t('team_access_loading_roles');
    },
    get team_access_no_roles_available() {
        return i18n.t('team_access_no_roles_available');
    },
    team_access_delete_confirm_body: function team_access_delete_confirm_body(name) {
        return i18n.t('team_access_delete_confirm_body', {
            name: name
        });
    },
    get team_access_resend_button() {
        return i18n.t('team_access_resend_button');
    },
    get team_access_reset_button() {
        return i18n.t('team_access_reset_button');
    },
    get team_access_error_load_users_roles() {
        return i18n.t('team_access_error_load_users_roles');
    },
    get team_access_error_update_user_roles() {
        return i18n.t('team_access_error_update_user_roles');
    },
    get team_access_error_delete_user() {
        return i18n.t('team_access_error_delete_user');
    },
    get team_access_error_resend_email() {
        return i18n.t('team_access_error_resend_email');
    },
    get team_access_error_reset_password() {
        return i18n.t('team_access_error_reset_password');
    },
    get team_access_error_unexpected() {
        return i18n.t('team_access_error_unexpected');
    },
    team_access_error_some_users_could_not_be_added: function team_access_error_some_users_could_not_be_added(errors) {
        return i18n.t('team_access_error_some_users_could_not_be_added', {
            errors: errors
        });
    },
    team_access_error_failed_to_add_users: function team_access_error_failed_to_add_users(errors) {
        return i18n.t('team_access_error_failed_to_add_users', {
            errors: errors
        });
    },
    get team_access_role_tooltip_admin_title() {
        return i18n.t('team_access_role_tooltip_admin_title');
    },
    get team_access_role_tooltip_admin_desc() {
        return i18n.t('team_access_role_tooltip_admin_desc');
    },
    get team_access_role_tooltip_editor_title() {
        return i18n.t('team_access_role_tooltip_editor_title');
    },
    get team_access_role_tooltip_editor_desc() {
        return i18n.t('team_access_role_tooltip_editor_desc');
    },
    get team_access_role_tooltip_viewer_title() {
        return i18n.t('team_access_role_tooltip_viewer_title');
    },
    get team_access_role_tooltip_viewer_desc() {
        return i18n.t('team_access_role_tooltip_viewer_desc');
    },
    get team_access_role_tooltip_viewer_note() {
        return i18n.t('team_access_role_tooltip_viewer_note');
    },
    get team_access_date_unknown() {
        return i18n.t('team_access_date_unknown');
    },
    // --------------------- End Team Access Page ----------------------
    // --------------------- User Groups Page --------------------------
    get user_groups_access_denied_title() {
        return i18n.t('user_groups_access_denied_title');
    },
    get user_groups_access_denied_desc() {
        return i18n.t('user_groups_access_denied_desc');
    },
    get user_groups_header_description() {
        return i18n.t('user_groups_header_description');
    },
    get user_groups_add_button() {
        return i18n.t('user_groups_add_button');
    },
    get user_groups_loading() {
        return i18n.t('user_groups_loading');
    },
    get user_groups_error_load_data() {
        return i18n.t('user_groups_error_load_data');
    },
    get user_groups_error_save_group() {
        return i18n.t('user_groups_error_save_group');
    },
    get user_groups_error_delete_group() {
        return i18n.t('user_groups_error_delete_group');
    },
    get user_groups_select_app_before_create() {
        return i18n.t('user_groups_select_app_before_create');
    },
    get user_groups_update_success() {
        return i18n.t('user_groups_update_success');
    },
    get user_groups_add_success() {
        return i18n.t('user_groups_add_success');
    },
    get user_groups_delete_success() {
        return i18n.t('user_groups_delete_success');
    },
    get user_groups_no_groups_found() {
        return i18n.t('user_groups_no_groups_found');
    },
    get user_groups_table_header_name() {
        return i18n.t('user_groups_table_header_name');
    },
    get user_groups_table_header_description() {
        return i18n.t('user_groups_table_header_description');
    },
    get user_groups_table_header_members() {
        return i18n.t('user_groups_table_header_members');
    },
    get user_groups_table_header_date_added() {
        return i18n.t('user_groups_table_header_date_added');
    },
    get user_groups_table_header_actions() {
        return i18n.t('user_groups_table_header_actions');
    },
    user_groups_delete_confirm_body: function user_groups_delete_confirm_body(name) {
        return i18n.t('user_groups_delete_confirm_body', {
            name: name
        });
    },
    // --------------------- End User Groups Page ----------------------
    // --------------------- Theme Page -------------------------------
    get theme_login_title() {
        return i18n.t('theme_login_title');
    },
    get theme_login_desc() {
        return i18n.t('theme_login_desc');
    },
    get theme_switch_customize_login() {
        return i18n.t('theme_switch_customize_login');
    },
    get theme_switch_customize_headers() {
        return i18n.t('theme_switch_customize_headers');
    },
    get theme_field_background_color() {
        return i18n.t('theme_field_background_color');
    },
    get theme_field_button_color() {
        return i18n.t('theme_field_button_color');
    },
    get theme_field_button_text_color() {
        return i18n.t('theme_field_button_text_color');
    },
    get theme_field_welcome_message_color() {
        return i18n.t('theme_field_welcome_message_color');
    },
    get theme_custom_color() {
        return i18n.t('theme_custom_color');
    },
    get theme_label_page_image() {
        return i18n.t('theme_label_page_image');
    },
    get theme_alt_page_image() {
        return i18n.t('theme_alt_page_image');
    },
    get theme_alt_page_preview() {
        return i18n.t('theme_alt_page_preview');
    },
    get theme_section_headers_title() {
        return i18n.t('theme_section_headers_title');
    },
    get theme_section_headers_desc() {
        return i18n.t('theme_section_headers_desc');
    },
    get theme_field_header_background() {
        return i18n.t('theme_field_header_background');
    },
    get theme_field_workspace_name() {
        return i18n.t('theme_field_workspace_name');
    },
    get theme_helper_workspace_name() {
        return i18n.t('theme_helper_workspace_name');
    },
    get theme_field_workspace_name_color() {
        return i18n.t('theme_field_workspace_name_color');
    },
    get theme_switch_use_logo() {
        return i18n.t('theme_switch_use_logo');
    },
    get theme_switch_show_workspace_name() {
        return i18n.t('theme_switch_show_workspace_name');
    },
    get theme_switch_show_deloitte_logo() {
        return i18n.t('theme_switch_show_deloitte_logo');
    },
    get theme_alt_deloitte_logo() {
        return i18n.t('theme_alt_deloitte_logo');
    },
    get theme_alt_logo_in_header() {
        return i18n.t('theme_alt_logo_in_header');
    },
    get theme_preview_product_name() {
        return i18n.t('theme_preview_product_name');
    },
    get theme_preview_button_text() {
        return i18n.t('theme_preview_button_text');
    },
    get theme_headers_preview_placeholder() {
        return i18n.t('theme_headers_preview_placeholder');
    },
    // --------------------- End Theme Page ---------------------------
    // --------------------- API Error Messages -----------------------
    get api_error_network_error() {
        return i18n.t('api_error_network_error');
    },
    get api_error_timeout() {
        return i18n.t('api_error_timeout');
    },
    get api_error_cors_error() {
        return i18n.t('api_error_cors_error');
    },
    get api_error_unauthorized() {
        return i18n.t('api_error_unauthorized');
    },
    get api_error_forbidden() {
        return i18n.t('api_error_forbidden');
    },
    get api_error_not_found() {
        return i18n.t('api_error_not_found');
    },
    get api_error_bad_request() {
        return i18n.t('api_error_bad_request');
    },
    get api_error_rate_limited() {
        return i18n.t('api_error_rate_limited');
    },
    get api_error_server_error() {
        return i18n.t('api_error_server_error');
    },
    get api_error_name_duplication() {
        return i18n.t('api_error_name_duplication');
    },
    get api_error_mandatory_fields_missing() {
        return i18n.t('api_error_mandatory_fields_missing');
    },
    get api_error_service_unavailable() {
        return i18n.t('api_error_service_unavailable');
    },
    // --------------------- Notification Icon Titles -----------------
    get notification_title_default() {
        return i18n.t('notification_title_default');
    },
    get notification_title_publication() {
        return i18n.t('notification_title_publication');
    },
    get notification_title_issue() {
        return i18n.t('notification_title_issue');
    },
    get notification_title_scheduled_outage() {
        return i18n.t('notification_title_scheduled_outage');
    },
    get notification_title_feedback() {
        return i18n.t('notification_title_feedback');
    },
    get notification_title_survey() {
        return i18n.t('notification_title_survey');
    },
    get notification_title_upgrade() {
        return i18n.t('notification_title_upgrade');
    },
    get notification_title_maintenance() {
        return i18n.t('notification_title_maintenance');
    },
    // --------------------- Time Ago Suffix ---------------------------
    get time_ago_suffix() {
        return i18n.t('time_ago_suffix');
    },
    // --------------------- Survey Button ---------------------------
    get get_started_button() {
        return i18n.t('get_started_button');
    }
    // --------------------- End File Input Buttons ----------------------
};
export var SETTINGS_VALIDATION = {
    nameAllowedChars: /^[A-Za-z .-]+$/,
    nameHasLetter: /[A-Za-z]/,
    maxNameLength: 50,
    reloadDelay: 100
};
export var ROUTES = {
    HOME: '/',
    SETTINGS: '/settings',
    USER_MANAGEMENT: '/userManagement',
    APPS: '/apps',
    PRODUCT: '/:product/*',
    TERMS_OF_USE: '/terms-of-use',
    HELP: '/help',
    ERROR: '/error'
};
export var RBAC_CONSTANTS = {
    rbac_user_status_active: 'active',
    rbac_user_status_pending: 'pending',
    rbac_user_status_inactive: 'inactive'
};
export var PROFILE_PICTURE_CACHE_KEY = 'profile_picture';
export var PLATFORM_HOST_KEY = 'REACT_PLATFORM_HOST';
